var map = {
	"./correct.mp3": 4118,
	"./deviceSound/banshou.mp3": 1073,
	"./deviceSound/broadcastEmergencyInfoPlay.mp3": 7097,
	"./deviceSound/buttonPress.mp3": 1089,
	"./deviceSound/buttonRun.mp3": 4894,
	"./deviceSound/closeFanWindow.mp3": 4674,
	"./deviceSound/deviceRun.mp3": 2158,
	"./deviceSound/fanDeviceRun.mp3": 6122,
	"./deviceSound/fireAlarm.mp3": 1256,
	"./deviceSound/key.mp3": 4300,
	"./deviceSound/phoneRing.mp3": 8312,
	"./deviceSound/phoneWaiting.mp3": 277,
	"./deviceSound/superviseAlarm.mp3": 6612,
	"./deviceSound/troubleAlarm.mp3": 8816,
	"./error.mp3": 6322,
	"./operation.mp3": 8680,
	"./oral.mp3": 7445,
	"./recognize.mp3": 4749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 955;